import Icon from 'icons/Icon';
import React, { useEffect, useState } from 'react';
import { MenuPermission, PermissionType } from '../../../domain/rbac/RbacDomains';
import RoleHelper from '../../../RoleHelper';
import LanguageUtil from '../../../util/LanguageUtil';

const PermissionContainer = (props: PermissionProps) => {
  const [menus, setMenus] = useState<Array<MenuPermission>>();
  const [menuDataSource, setMenuDataSource] = useState(Array<MenuRecord>);
  const { onMenuChange } = props;

  useEffect(() => {
    props.menu && setMenuDataSource(buildMenuChildren(props.menu));
  }, []);

  useEffect(() => {
    menus && onMenuChange(menus);
  }, [menus]);

  const buildMenuChildren = (menu: Array<MenuPermission>): Array<MenuRecord> => {
    return menu.map((m) => {
      const record: MenuRecord = {
        key: m.baseMenu,
        menu: m,
      };
      if (m.subMenu.length > 0) {
        record.children = buildMenuChildren(m.subMenu);
      }
      return record;
    });
  };

  const onChangePermission = (e: any, record: MenuRecord) => {
    if (!RoleHelper.canManage('Role')) return;
    record.menu.permission = e;
    if (record.menu.subMenu.length > 0) {
      record.menu.subMenu = changeSubPermission(record.menu.subMenu, e);
    }
    const newMenus = props.menu?.map((menu) => {
      if (menu.baseMenu == record.menu.baseMenu) {
        return record.menu;
      } else if (menu.subMenu && menu.subMenu.length > 0 && record.menu.subMenu.length <= 0) {
        menu.subMenu.map((subMenu) => {
          if (subMenu.baseMenu == record.menu.baseMenu) {
            return record.menu;
          } else {
            return subMenu;
          }
        });
        return menu;
      } else return menu;
    });
    setMenus(newMenus);
  };

  const changeSubPermission = (menus: Array<MenuPermission>, value: PermissionType): Array<MenuPermission> => {
    if (!RoleHelper.canManage('Role')) return menus;
    return menus.map((m) => {
      m.permission = value;
      if (m.subMenu.length > 0) {
        m.subMenu = changeSubPermission(m.subMenu, value);
      }
      return m;
    });
  };

  const formatString = (value: string) => {
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  const getMenuName = (menuName: string) => {
    switch (menuName) {
      case 'Cases':
        return LanguageUtil.get({ id: 'common.label.transaction', defaultMessage: 'Transaction' });
      case 'Case Configuration':
        return LanguageUtil.get({ id: 'common.label.transaction', defaultMessage: 'Transaction' }) + ' Config';
      case 'Transaction':
        return LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' });
      case 'Stream':
        return LanguageUtil.get({ id: 'common.label.store', defaultMessage: 'Store' });
      case 'ACH':
        return LanguageUtil.get({ id: 'common.label.ach', defaultMessage: 'ACH' });
      case 'Graph':
        return LanguageUtil.get({ id: 'common.label.graph', defaultMessage: 'Graph' });
      case 'Entity':
        return LanguageUtil.get({ id: 'common.label.entity', defaultMessage: 'Entity' });
      case 'Watchlist':
        return LanguageUtil.get({ id: 'common.label.watchlist', defaultMessage: 'Watchlist' });
      case 'WatchlistAlert':
        return LanguageUtil.get({ id: 'common.label.watchlistAlert', defaultMessage: 'Watchlist Alert' });
      case 'CustomList':
        return LanguageUtil.get({ id: 'common.label.customList', defaultMessage: 'Custom List' });
      case 'List':
        return LanguageUtil.get({ id: 'common.label.list', defaultMessage: 'List' });
      case 'Dashboard':
        return LanguageUtil.get({ id: 'common.label.dashboard', defaultMessage: 'Dashboard' });
      case 'Watchlist':
        return LanguageUtil.get({ id: 'common.label.watchlist', defaultMessage: 'Watchlist' });
      case 'Watchlist Alert':
        return LanguageUtil.get({ id: 'common.label.watchlistAlert', defaultMessage: 'Watchlist Alert' });
      case 'Custom List':
        return LanguageUtil.get({ id: 'common.label.customList', defaultMessage: 'Custom List' });
      case 'Enrichment':
        return LanguageUtil.get({ id: 'common.label.enrichment', defaultMessage: 'Enrichment' });
      case 'Rule':
        return LanguageUtil.get({ id: 'common.label.rule', defaultMessage: 'Rule' });
      case 'Action':
        return LanguageUtil.get({ id: 'common.label.action', defaultMessage: 'Action' });
      case 'Configuration':
        return LanguageUtil.get({ id: 'common.label.configuration', defaultMessage: 'Configuration' });
      case 'Connection':
        return LanguageUtil.get({ id: 'common.label.connection', defaultMessage: 'Connection' });
      case 'Struct':
        return LanguageUtil.get({ id: 'common.label.struct', defaultMessage: 'Struct' });
      case 'Sandbox':
        return LanguageUtil.get({ id: 'common.label.sandbox', defaultMessage: 'Sandbox' });
      case 'Sandbox Simulator':
        return LanguageUtil.get({ id: 'common.label.sandboxSimulator', defaultMessage: 'Sandbox Simulator' });
      case 'Sandbox Csv':
        return LanguageUtil.get({ id: 'common.label.sandboxCsv', defaultMessage: 'Sandbox Csv' });
      case 'Sandbox Json':
        return LanguageUtil.get({ id: 'common.label.sandboxJson', defaultMessage: 'Sandbox Json' });
      case 'Sandbox Database':
        return LanguageUtil.get({ id: 'common.label.sandboxDatabase', defaultMessage: 'Sandbox Database' });
      case 'Ai-Model':
        return LanguageUtil.get({ id: 'common.label.aiModel', defaultMessage: 'Ai-Model' });
      case 'Tracker':
        return LanguageUtil.get({ id: 'common.label.tracker', defaultMessage: 'Tracker' });
      case 'Enrichment Velocity':
        return LanguageUtil.get({ id: 'common.label.enrichmentVelocity', defaultMessage: 'Enrichment Velocity' });
      case 'Enrichment List':
        return LanguageUtil.get({ id: 'common.label.enrichmentList', defaultMessage: 'Enrichment List' });
      case 'Enrichment Api':
        return LanguageUtil.get({ id: 'common.label.enrichmentApi', defaultMessage: 'Enrichment Api' });
      case 'Enrichment Query':
        return LanguageUtil.get({ id: 'common.label.enrichmentQuery', defaultMessage: 'Enrichment Query' });
      case 'Enrichment Basic':
        return LanguageUtil.get({ id: 'common.label.enrichmentBasic', defaultMessage: 'Enrichment Basic' });
      case 'Table List':
        return LanguageUtil.get({ id: 'common.label.tableList', defaultMessage: 'Table List' });
      case 'Query List':
        return LanguageUtil.get({ id: 'common.label.queryList', defaultMessage: 'Query List' });
      case 'Collection List':
        return LanguageUtil.get({ id: 'common.label.collectionList', defaultMessage: 'Collection List' });
    }
    return menuName;
  };

  const PermissionItem = (m: MenuRecord) => {
    const [visible, setVisible] = useState<boolean>(false);
    const menuName: string = formatString(m.menu.baseMenu);
    return (
      <div className={`flex flex-col w-full text-md`}>
        <div className={'flex justify-between gap-x-2  py-1'}>
          <div className={`${m.children && 'hover:cursor-pointer'} flex gap-x-1 items-center`}>
            {m.children ? (
              <Icon
                onClick={() => {
                  if (!RoleHelper.canManage('Role')) return;
                  setVisible(!visible);
                }}
                icon={'arrow-right'}
                size={14}
              />
            ) : (
              <Icon
                onClick={() => {
                  if (!RoleHelper.canManage('Role')) return;
                  setVisible(false);
                }}
                icon={'multiplier'}
                size={14}
              />
            )}
            <p className={'truncate'}>{getMenuName(menuName)}</p>
          </div>
          <div className={'flex border rounded-[3px] h-[34px] p-1 w-[250px] max-w-[250px] bg-[#F7F8FA]'}>
            <div
              id={'No Permission'}
              className={`permission-item border-none rounded-[3px] ${m.menu.permission == 'No Permission' ? '!bg-white  text-primary' : 'opacity-50'}`}
              onClick={(e) => {
                if (!RoleHelper.canManage('Role')) return;
                onChangePermission(e.currentTarget.id, m);
              }}
            >
              <Icon icon={'multiplier'} size={12} />
              None
            </div>
            <div
              id={'View'}
              className={`permission-item border-none rounded-[3px] ${m.menu.permission == 'View' ? '!bg-white  text-primary' : 'opacity-50'}`}
              onClick={(e) => {
                if (!RoleHelper.canManage('Role')) return;
                onChangePermission(e.currentTarget.id, m);
              }}
            >
              <Icon icon={'eye'} size={12} />
              View
            </div>
            <div
              id={'Edit'}
              className={`permission-item border-none rounded-[3px] ${m.menu.permission == 'Edit' ? '!bg-white  text-primary' : 'opacity-50'}`}
              onClick={(e) => {
                if (!RoleHelper.canManage('Role')) return;
                onChangePermission(e.currentTarget.id, m);
              }}
            >
              <Icon icon={'edit'} size={12} />
              Edit
            </div>
          </div>
        </div>
        <div className={`${visible && m.children ? 'visible' : 'hidden'}`}>
          {m.children?.map((c) => (
            <div className={'pl-2'} key={c.key}>
              <PermissionItem key={c.key} menu={c.menu} children={c.children} />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      {menuDataSource.map((m) => {
        return (
          <div className={'flex flex-col gap-y-2'} key={m.key}>
            <PermissionItem key={m.key} menu={m.menu} children={m.children} />
          </div>
        );
      })}
    </div>
  );
};

interface PermissionProps {
  menu: MenuPermission[];
  onMenuChange: (menu: MenuPermission[]) => void;
}

type MenuRecord = {
  key: string;
  menu: MenuPermission;
  children?: Array<MenuRecord>;
};

export default PermissionContainer;
